import { cn } from '@/lib/utils';

export function BrandSparkle({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 16 16" className={className} aria-hidden fill="currentColor">
      <path d="M8 0 L9.7 6.3 L16 8 L9.7 9.7 L8 16 L6.3 9.7 L0 8 L6.3 6.3 Z" />
    </svg>
  );
}

export function SecurityShield({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <path
        d="M24 4 L40 10 V23 C40 33.5 33 41.5 24 44 C15 41.5 8 33.5 8 23 V10 Z"
        fill="var(--brand-terracotta)"
      />
      <path
        d="M17 24 l5 5 l9 -10"
        fill="none"
        stroke="var(--primary-foreground)"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GoldConnector({ className }: { className?: string }) {
  return (
    <span className={cn('flex shrink-0 items-center gap-1.5', className)} aria-hidden>
      <span className="h-1.5 w-1.5 rounded-full bg-brand-gold/70" />
      <span className="w-7 border-t-2 border-dotted border-brand-gold/40" />
      <span className="h-1.5 w-1.5 rounded-full bg-brand-gold/70" />
    </span>
  );
}
